import { siteInfo } from "@/constants";
import { getFromLocale } from "../methods";

export const getSiteInfo = () => {
    const language = getFromLocale("language");
    const currency = getFromLocale("currency");
    let siteName = '', type = '';
    const isBrowser = () => typeof window !== "undefined";
    
    if (isBrowser()) {
        const windowObject = window.location.hostname.replace(/^www\./, "");
        if (windowObject === "sayt.az" || windowObject === "localhost") {
            siteName = 'sayt.az';
            type = '0'
        } else if (windowObject === "websiteca.com") {
            siteName = 'websiteca.com';
            type = '1'
        }
    }
    const defaultLanguage = siteInfo.defaultLanguage[siteName];
    const defaultCurrency = siteInfo.defaultCurrency[siteName];

    const lang = language ?? siteInfo.defaultLanguage[siteName];
    const curr = currency ?? siteInfo.defaultCurrency[siteName];

    return { lang, curr, type, siteName,defaultLanguage,defaultCurrency };
}
